import { Accordion, AccordionItem as Item } from "@szhsin/react-accordion";
import chevronDown from "../../../assets/chevron-down.svg";
import styles from "../../../styles.module.css";
import '../../../output.css';
import visa from "../../../assets/visa.svg";
import mastercard from "../../../assets/mastercard.svg";
import americanexpress from "../../../assets/americanexpress.svg";
import codinensa from "../../../assets/codensa.svg";
import efecty from "../../../assets/efecty.svg";

import visadebito from "../../../assets/visa-debito.svg";
const paymentMethodStyle = {
    marginBottom: '20px',
  };

  const paymentHeadingStyle = {
    fontSize: '18px',
    marginBottom: '10px',
    color: '#fff',
  };

  const imageStyle = {
    height: '30px',
    margin: '0 10px 10px 0',
  };

  const columnStyle = {
    flex: '1 1 300px',
    backgroundColor: '#222',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  };

  const headingStyle = {
    fontSize: '24px',
    marginBottom: '20px',
    color: '#fff',
  };

  
/**
 * @type {React.ExoticComponent<import('@szhsin/react-accordion').AccordionItemProps>}
 */
const AccordionItem = ({ header, ...rest  }) => (
  <Item
  style={{ border: "none", color: "#fff" }}
    {...rest}
    header={
      <>
        {header}
        <img className={styles.chevron} src={chevronDown} alt="Chevron Down" />
      </>
    }
    className={styles.item}
    buttonProps={{
      className: ({ isEnter }) =>
        `${styles.itemBtn} ${isEnter && styles.itemBtnExpanded} btn-accor ${styles.hoverClass}`,
    }}
    contentProps={{ className: styles.itemContent }}
    panelProps={{ className: styles.itemPanel }}
  />
);

function Desc({desc}) {
  return (   <div style={columnStyle}>
            <h2 style={headingStyle}>Medios de pago</h2>
            <div style={paymentMethodStyle}>
              <h3 style={paymentHeadingStyle}>Tarjetas de Crédito</h3>
              <p style={{ marginBottom: '10px', color: "#fff" }}>¡Paga en hasta 48 cuotas!</p>
              <img src={visa} alt="Visa" style={imageStyle} />
              <img src={mastercard} alt="Mastercard" style={imageStyle} />
              <img src={americanexpress} alt="American Express" style={imageStyle} />
              <img src={codinensa} alt="Codensa" style={imageStyle} />
            </div>
            <div style={paymentMethodStyle}>
              <h3 style={paymentHeadingStyle}>Tarjetas de Débito</h3>
              <img src={visadebito} alt="Visa Débito" style={imageStyle} />
              <img src={mastercard} alt="Mastercard Débito" style={imageStyle} />
            </div>
            <div style={paymentMethodStyle}>
              <h3 style={paymentHeadingStyle}>Efectivo</h3>
              <img src={efecty} alt="Efecty" style={imageStyle} />
            </div>
          </div>
  )
}

export default function AccordionBikeMethod({ data, setSize }) {
  

  return (
    <div className={styles.container} style={{width: "440px",  borderRadius: "5px", background: "#222", boxShadow: "none"}} >
      <div className={styles.accordion} style={{width: "400px", borderTop: "none", color: "#fff"}}>
        {/* `transitionTimeout` prop should be equal to the transition duration in CSS */}
        <Accordion transition transitionTimeout={250}>
          <div style={{width: "100%"}}>
          <AccordionItem header="Métodos de pago">
           <Desc></Desc>
          </AccordionItem>
          </div>
        </Accordion>
      </div>
    </div>
  );
}
